function OrganismePhotoLogout (props) {
  return (
    <div className='login-img-container'>
      <div className="logout-img"/>
    </div>
  );
}

export default OrganismePhotoLogout;
